import React from 'react'

require('ta-semantic-ui/semantic/dist/components/button.css')
require('ta-semantic-ui/semantic/dist/components/label.css')
require('./styles.scss')

const LOADING = 'loading'
const PAUSED = 'paused'
const PLAYING = 'playing'

/**
 * Very simple audio player component. Shows a play button that starts and
 * pauses the audio.
 *
 * @param {string} props.source The source URL of the audio file to play.
 * @param {string} props.audioTitle The name of the audio.
 */
export default class AudioPlayer extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      iconStatus: PAUSED,
      wantsToPlay: false
    }

    // Set up dataLayer for event tracking
    // This assumes we have GTM set up, otherwise not much will happen.
    window.dataLayer = window.dataLayer || []

    this.togglePlayStatus = this.togglePlayStatus.bind(this)
    this.playbackEndedHandler = this.playbackEndedHandler.bind(this)
    this.loadHandler = this.loadHandler.bind(this)
    this.canPlayThroughHandler = this.canPlayThroughHandler.bind(this)
  }

  renderIcon() {
    switch (this.state.iconStatus) {
      case LOADING:
        return <i className='loading circle notched fitted icon' />

      case PLAYING:
        return <i className='pause fitted icon' />

      case PAUSED:
        return <i className='play fitted icon' />
    }
  }

  render() {
    return (
      <span className='audioplayer' onClick={this.togglePlayStatus}>
        {this.props.children}&nbsp;
        <a
          className='ui horizontal teal tiny icon label'
          title={this.props.audioTitle}
        >
          {this.renderIcon()} Audio
        </a>
        <audio
          onEnded={this.playbackEndedHandler}
          onLoadedData={this.loadHandler}
          onCanPlayThrough={this.canPlayThroughHandler()}
          src={this.props.source}
          type='audio/aac'
          ref={element => {
            this.player = element
          }}
        />
      </span>
    )
  }

  loadHandler() {
    if (this.player.readyState >= 3 && this.state.wantsToPlay) {
      this.player.play()
      this.setState({
        iconStatus: PLAYING,
        wantsToPlay: false
      })
    }
  }

  canPlayThroughHandler(event) {
    if (this.state.wantsToPlay) {
      this.player.play()
      this.setState({
        iconStatus: PLAYING,
        wantsToPlay: false
      })
    }
  }

  togglePlayStatus(event) {
    if (this.player.paused) {
      if (this.player.readyState >= 3) {
        this.player.play()
        this.setState({ iconStatus: PLAYING })
      } else {
        this.setState({
          wantsToPlay: true,
          iconStatus: LOADING
        })
      }
    } else {
      this.player.pause()
      this.setState({
        iconStatus: PAUSED
      })
    }
  }

  playbackEndedHandler(event) {
    this.setState({
      iconStatus: PAUSED
    })
  }
}

AudioPlayer.propTypes = {}
// source: React.PropTypes.string.isRequired,
// audioTitle: React.PropTypes.string.isRequired,
// children: React.PropTypes.node

AudioPlayer.defaultProps = {}
